import * as Scrivito from "scrivito";
import { Helmet } from "react-helmet-async";
import setLanguage from "^/utils/setLanguage";
import { richSnippetsJSONOrganization } from "../../richSnippetsJSON";
import logo from "../../assets/images/logo_color_de.png";

Scrivito.provideComponent("Homepage", ({ page }) => {
  setLanguage(page);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {richSnippetsJSONOrganization(process.env.SCRIVITO_ORIGIN, logo)}
        </script>
      </Helmet>
      <Scrivito.ContentTag
        tag="div"
        content={page}
        attribute="body"
        role="main"
      />
    </>
  );
});
